export default __webpack_public_path__ + "static/media/Angkor-Regular.e187e32e.ttf";